module.exports = __webpack_public_path__ + "static/img/Store-15.95e18e3a.png";